import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_265: DocMigration = {
  maxSchemaVersion: "0.0.265",
  description: "Move roof instance rightSlope and rightSlopes to roofSideOverrides",
  apply(json: any): any {
    const roofs = {};

    for (const id in json.roofs) {
      const roof = json.roofs[id];
      const { roofSettings = {} } = roof;
      let { roofSideOverrides = {} } = roof;
      const { rightSlope, rightSlopes } = roofSettings;

      if (rightSlope !== undefined || rightSlopes !== undefined) {
        roofSideOverrides = {
          ...roofSideOverrides,
          RIGHT: {
            ...roofSideOverrides.RIGHT,
            slope: rightSlope,
            slopeOptions: rightSlopes,
          },
        };

        delete roofSettings.rightSlope;
        delete roofSettings.rightSlopes;
      }

      roofs[id] = {
        ...roof,
        roofSideOverrides,
      };
    }

    return {
      ...json,
      roofs,
    };
  },
};

export default migration_0_0_265;
